import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import * as yup from 'yup';

import Axios from '../../../Assets/Axios/Axios';

import { useToastContext } from '../../../Context/ToastContext';

import { COLORS } from '../../../Constant/COLORS';
import { EMAIL_TEMPLATES } from '../../../Constant/Enums';

import { useFormContext } from './FormContext';

import { FindProfessionalByEmail, SendCode } from '../../../Server/Query';

function Email() {
  const { showToastMessage } = useToastContext();
  const { inputs, updateInputs, nextStep, emailOtpReferenceId } =
    useFormContext();

  const [error, setError] = useState(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  function handleChange(event) {
    updateInputs({ email: event.target.value });
  }

  async function handleSubmit(event) {
    // try {
    //   event.preventDefault();
    //   setIsSubmitDisabled(true);
    //   setError(null);

    //   const email = await emailSchema.validate(inputs.email);

    //   const { error, data } = await checkEmailUserExists(email);
    //   if (error) throw new Error();
    //   if (!data.isEmailUserExists) {
    //     showToastMessage('Email is not associated with an account');
    //     return undefined;
    //   }

    //   const result = await sendVerificationCode(email);
    //   if (result.error) throw new Error();

    //   emailOtpReferenceId.current = result.data.referenceId;
    //   nextStep();
    // } catch (error) {
    //   if (error instanceof yup.ValidationError) {
    //     setError(error.message);
    //     return undefined;
    //   }
    //   showToastMessage('Something went wrong');
    // } finally {
    //   setIsSubmitDisabled(false);
    // }
  }

  return (
    <Stack
      px={{ xs: 2, md: 10 }}
      pt={{ xs: 5, md: 10 }}
      pb={{ xs: 10, md: 20 }}
      gap={4}
    >
      <Typography variant='h6' variantMapping={{ h6: 'h1' }} textAlign='center'>
        Enter your email
      </Typography>
      <Box>
        <FormLabel htmlFor='phoneNo'>
          <Typography mb={1} color='black' fontWeight={500}>
            Email
          </Typography>
        </FormLabel>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          gap={2}
          component='form'
          onSubmit={handleSubmit}
          alignItems='flex-start'
        >
          <TextField
            fullWidth
            spellCheck={false}
            placeholder='example@domain.com'
            value={inputs.email}
            onChange={handleChange}
            error={Boolean(error)}
            helperText={error}
            autoComplete='email'
            InputProps={{ sx: { bgcolor: COLORS.grey9 } }}
          />

          <Button
            color='blue'
            sx={{
              width: 'fit-content',
              height: '40px',
              alignSelf: { xs: 'center', md: 'unset' },
            }}
            type='submit'
            disabled={isSubmitDisabled}
          >
            <ArrowForwardIcon htmlColor='white' />
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
}

const emailSchema = yup.string().trim().required().email().label('Email');

async function checkEmailUserExists(email) {
  const query = FindProfessionalByEmail({ email });
  const { data, errors } = await Axios(query);

  if (errors) return { error: true, data: null };

  const isEmailUserExists = Boolean(data.Professional);
  return { error: false, data: { isEmailUserExists } };
}

async function sendVerificationCode(email) {
  const query = SendCode({
    email,
    template: EMAIL_TEMPLATES.PASSWORD_RESET,
  });
  const { errors, data } = await Axios(query);

  if (errors) return { error: true, data: null };

  return { error: false, data: { referenceId: data.SendCode.referenceId } };
}

export default Email;
